export const TipoReporte = [
    {
        codigo: "AF",
        descripcion: "Afiliación"
    }, {
        codigo: "TR",
        descripcion: "Trasladado"
    }, {
        codigo: "RT",
        descripcion: "R Traslado"
    }, {
        codigo: "RA",
        descripcion: "R Afiliación"
    }];

export const obtenerTipoReporte = (codigo: string) => {
    return TipoReporte.find(tipoReporte => tipoReporte.codigo === codigo);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/empresas_trasladadas/modelo/TipoReporte.ts